import { Component, OnInit, Input, Output, EventEmitter, inject, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { PlanificacionService } from '../../../../../services/planificacion.service';
import { ModalComponent } from "../../../../modal/modal.component";
import { ProgramacionFormComponent } from "../../programacion-form/programacion-form.component";

@Component({
  selector: 'app-seleccion-aspirantes',
  standalone: true,
  imports: [CommonModule, FormsModule, ModalComponent, ProgramacionFormComponent],
  templateUrl: './seleccion-aspirantes.component.html',
  styleUrl: './seleccion-aspirantes.component.css'
})
export class SeleccionAspirantesComponent implements OnInit, AfterViewInit {
  @ViewChild(ModalComponent) mdl!: ModalComponent;
  @Input() user?: any;
  @Input() id_ambito?: string;
  @Input() year?: number;
  @Input() nom_ambito?: string;
  @Input() cupos?: number;
  @Input() organizaciones: any[] = [];

  @Output() vuelve = new EventEmitter<any>();
  titulo!: string;
  tipo_color!: string;
  letra_color!: string;
  mensaje!: string;

  rslEstudianteMaster: any[] = [];

  datosSeleccionadosPorOrganizacion: any = [];
  idsEstudiantesSeleccionados: any = [];

  idMetaRegional: any = [];
  nomOrganizacion: any = [];
  isPrograForm: boolean = false;

  private servicios = inject(PlanificacionService);
  private cdr = inject(ChangeDetectorRef); // Mantener ChangeDetectorRef

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.mdl.cargando();
    this.servicios.listarOrganizaciones(this.user.id_institucional.toString(), this.year!.toString(), this.id_ambito!, '1').subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        if ((rs.data.estudiante).length > 0) {
          this.rslEstudianteMaster = rs.data.estudiante.map((est: any) => ({
            ...est,
            isChecked: false
          }));

          this.organizaciones = this.organizaciones.map((org: any) => {
            this.idMetaRegional.push(org.id_meta_regional);
            console.log('organizaciones_traida:   ',org.cupoValue)
            return {
              ...org,
              searchTermEst: '',
              filteredEstudiante: [],
              assignedStudents: []
            };
          });

          this.organizaciones.forEach((_, index) => this.buscarEstudiantes(index));

        } else {
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = 'El ámbito seleccionado no tiene estudiantes disponibles o programados.';
          this.mdl.alerta();
        }
        console.log("Organizaciones con estudiantes inicializados:", this.organizaciones);
      },
      error: (err) => {
        this.mdl.cerrar();
        console.error("Error al cargar organizaciones y estudiantes:", err);
        this.titulo = '!ERROR¡';
        this.tipo_color = 'danger';
        this.letra_color = 'white';
        this.mensaje = 'Hubo un error al cargar los datos. Por favor, inténtelo de nuevo.';
        this.mdl.alerta();
      }
    });
  }

  buscarEstudiantes(originatorOrgIndex: number) {
    if (originatorOrgIndex >= 0 && originatorOrgIndex < this.organizaciones.length) {
      this.organizaciones.forEach((org, currentOrgIndex) => {
        const currentSearchTerm = this.quitarAcentos(org.searchTermEst.toLowerCase());

        const filtered = this.rslEstudianteMaster.filter((est: any) => {
          const nombre = est.nombre_full ? this.quitarAcentos(est.nombre_full.toLowerCase()) : '';
          const matchesSearch = nombre.includes(currentSearchTerm);
          const isAvailableOrAssignedToThisOrg = !est.isChecked || this.isEstudianteInOrg(est.id_estudiante, org.id_organizacion);
          return matchesSearch && isAvailableOrAssignedToThisOrg;
        });

        org.filteredEstudiante = [...filtered]; // Mantener la clonación del array

        // Forzar la detección de cambios para esta organización específica
        this.cdr.detectChanges();
      });
    }
  }

  onCheckboxChange(orgIndex: number, estudiante: any, event: Event, cupo: any) {
    const isChecked = (event.target as HTMLInputElement).checked;

    estudiante.isChecked = isChecked;

    if (isChecked) {
      this.assignEstudianteToOrg(estudiante.id_estudiante, this.organizaciones[orgIndex].id_organizacion);
    } else {
      this.removeEstudianteFromOrg(estudiante.id_estudiante, this.organizaciones[orgIndex].id_organizacion);
    }


    if(this.organizaciones[orgIndex].assignedStudents.length > cupo){
      this.titulo = '!ADVERTENCIA¡';
      this.tipo_color = 'warning';
      this.letra_color = 'dark';
      this.mensaje = `Cupo lleno segun meta asignada (${cupo}).`;
      this.mdl.alerta();
      (event.target as HTMLInputElement).checked = false;
      estudiante.isChecked = false;
      this.removeEstudianteFromOrg(estudiante.id_estudiante, this.organizaciones[orgIndex].id_organizacion);
    }


    // Re-filtrar todos los acordeones para reflejar el cambio global
    this.organizaciones.forEach((_, index) => this.buscarEstudiantes(index));

    // Forzar la detección de cambios después de un checkbox change
    // Esto es crucial ahora que controlamos el 'checked' explícitamente.
    this.cdr.detectChanges();
  }

  assignEstudianteToOrg(idEstudiante: number, idOrganizacion: number) {
    this.organizaciones.forEach(org => {
      if (org.id_organizacion !== idOrganizacion) {
        org.assignedStudents = org.assignedStudents ? org.assignedStudents.filter((id: number) => id !== idEstudiante) : [];
      }
    });

    const currentOrg = this.organizaciones.find(org => org.id_organizacion === idOrganizacion);
    if (currentOrg && !currentOrg.assignedStudents.includes(idEstudiante)) {
      currentOrg.assignedStudents.push(idEstudiante);
    }
  }


  removeEstudianteFromOrg(idEstudiante: number, idOrganizacion: number) {
    const currentOrg = this.organizaciones.find(org => org.id_organizacion === idOrganizacion);
    if (currentOrg) {
      currentOrg.assignedStudents = currentOrg.assignedStudents ? currentOrg.assignedStudents.filter((id: number) => id !== idEstudiante) : [];
    }
  }

  isEstudianteInOrg(idEstudiante: number, idOrganizacion: number): boolean {
    const org = this.organizaciones.find(o => o.id_organizacion === idOrganizacion);
    return org && org.assignedStudents && org.assignedStudents.includes(idEstudiante);
  }

  trackByEstId(index: number, est: any): number {
    return est.id_estudiante;
  }

  quitarAcentos(str: string): string {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  volver() {
    this.vuelve.emit({ value: false, validador: false, final: false });
  }

  procesarSeleccion() {

    this.mdl.cargando();
    this.datosSeleccionadosPorOrganizacion = this.obtenerDatosSeleccionadosPorOrganizacion();
    this.idsEstudiantesSeleccionados = this.obtenerTodosLosEstudiantesIdSeleccionados();

    let val = true;
    for (let index = 0; index < this.datosSeleccionadosPorOrganizacion.length; index++) {
      const dato = this.datosSeleccionadosPorOrganizacion[index];
      console.log('asdasd: ',dato.estudiantes.length)
      if(dato.cupo > dato.estudiantes.length){
        val = false;
        break;
      }
    }

    console.log('Datos seleccionados por organización:', this.datosSeleccionadosPorOrganizacion);
    console.log('IDs de todos los estudiantes seleccionados (consolidado):', this.idsEstudiantesSeleccionados);
    console.log('cantidad organizaciones:', this.organizaciones.length);
    //console.log('metas regionales: ',this.idMetaRegional);

    if(val && this.datosSeleccionadosPorOrganizacion.length == this.organizaciones.length){
      this.mdl.cerrar();
      this.isPrograForm = true;
    }
    else{
      this.mdl.cerrar();
      this.titulo = '!ADVERTENCIA¡';
      this.tipo_color = 'warning';
      this.letra_color = 'dark';
      this.mensaje = `Debe asignar a las organizaciones la cantidad de estudiantes por cupos establecidos.`;
      this.mdl.alerta();
    }



    /*
    this.vuelve.emit({
       value: false,
       validador: true,
       final: true,
       datosPorOrganizacion: datosSeleccionadosPorOrganizacion,
       idsEstudiantes: idsEstudiantesSeleccionados
     });
     */
  }

  obtenerDatosSeleccionadosPorOrganizacion(): any[] {
    const datosFinales: any[] = [];

    this.organizaciones.forEach((org: any) => {
      const estudiantesSeleccionados = org.assignedStudents ?
       this.rslEstudianteMaster.filter((est: any) => est.isChecked && org.assignedStudents.includes(est.id_estudiante)) : [];

      if (estudiantesSeleccionados.length > 0) {
        this.nomOrganizacion.push(org.organizacion)

        datosFinales.push({
          id_organizacion: org.id_organizacion,
          organizacion: org.organizacion,
          cupo: org.cupoValue,
          estudiantes: estudiantesSeleccionados.map((est: any) => ({
            id_estudiante: est.id_estudiante,
            nombre_full: est.nombre_full
          }))
        });
      }
    });
    return datosFinales;
  }

  obtenerTodosLosEstudiantesIdSeleccionados(): number[] {
    return this.rslEstudianteMaster.filter((est: any) => est.isChecked).map((est: any) => est.id_estudiante);
  }

  volver_programa(valor: any){
    if(valor.validador){
      this.vuelve.emit({value: false, validador: true, final: true});
    }
    this.isPrograForm = valor.value;
    console.log('asdasd:  ',valor.cupo)
  }

}
